import { formatMessage } from "@local/legacy-utils/i18nHelper";

export const projectsTypeLabel = {
  open: formatMessage({ id: "pages.project.details.utils.constants.open" }),
  direct: formatMessage({ id: "pages.project.details.utils.constants.direct" }),
  unsolicited: formatMessage({
    id: "pages.project.details.utils.constants.unsolicited",
  }),
};
